'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagOmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.22869e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -4.01451e-05 6.66667 6.22869e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#138E16"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H9.33333V13.3333H28V6.66667H9.33333V0H6.22869e-06L0 20Z",
          fill: "#ED2B35"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66667 4.71176L3.50964 6.40258L4.11019 4.44377L2.06686 4.59339L3.97275 3.84162L2.58178 2.33736L4.35785 3.35873L4.66667 1.33333L4.97549 3.35873L6.75155 2.33736L5.36058 3.84162L7.26647 4.59339L5.22314 4.44377L5.82369 6.40258L4.66667 4.71176Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagOmAsset = forwardRef(FlagOmAsset);

export { VpFlagOmAsset as default };
